// extracted by mini-css-extract-plugin
export default {"textWrapper":"TextWrapper_textWrapper__cE82C"};